import type { ProductActionsDefinition } from '@hopdrive/feature-portal-products';

import { appendSearch } from '@utils/appendSearch';

/**
 * A product's header actions with the embed's query string carried onto every creation method and
 * secondary action that is a route (`to`), so a click on Plan Moves, Import Moves, or Manage
 * Drivers keeps the hash session, the rooftop, and `readOnly`. An action that opens a dialog is
 * left as it is. The identity on an empty search.
 */
export function withActionsSearch(actions: ProductActionsDefinition, search: string): ProductActionsDefinition {
  if (!search) return actions;
  const withSearch = <T extends { to?: string }>(action: T): T => (action.to ? { ...action, to: appendSearch(action.to, search) } : action);
  return {
    ...actions,
    creation: actions.creation.map(withSearch),
    ...(actions.secondary ? { secondary: withSearch(actions.secondary) } : {}),
  };
}
